<script>
import edpDatePicker from "@/components/e-form/edp-date-picker.vue";
import { FieldUpdateDb } from "@/utils/FieldUpdate";
import EdpSelect from "@/components/e-form/edp-select.vue";
import appsettings from "@/utils/appsettings";

export default {
  name: "dashboard-table",
  props: {
    dataSource: {
      type: Array,
      default: () => []
    },
    issues_level: {
      type: Array,
      default: () => []
    },
    task_status: {
      type: Array,
      default: () => []
    },
  },
  components: { EdpSelect, edpDatePicker },
  data() {
    return {
      dbs: {
        prjIssue: new FieldUpdateDb("prj", "prj_issue"),
      },
      appsettings: appsettings,
    }
  },
  methods: {
    customRow(record) {
      return {
        on: {
          click: () => {
            this.$parent.$parent.detailOid = record.oid
            this.$parent.$parent.detailType = record.issue_type
          }
        }
      }
    },
    openTaskDetailModal(row) {
      this.$parent.$parent.openTaskDetailModal(row)
    },
  },
  computed:{
    issues_level_list() {
      return this.issues_level.slice().reverse();
    },
  }
}
</script>

<template>
  <a-table
      :data-source="dataSource"
      rowKey="oid"
      :pagination="false"
      :customRow="customRow"
  >
    <a-table-column title="ID" data-index="seqid" width="70px"></a-table-column>
    <a-table-column title="标题" data-index="issue_name">
      <template slot-scope="scope, row">
        <div class="edp-title">
          <template v-if="row.issue_type === 'R'">
            <!--                  需求-->
            <img class="icon" v-if="row.is_later" :src="$toUrl('req_later.png')">
            <img class="icon" v-else-if="row.issue_status === '0'" :src="$toUrl('req.png')">
            <img class="icon" v-else-if="row.issue_status === '1'" :src="$toUrl('req_progress.png')">
            <img class="icon" v-else-if="row.issue_status === '100'" :src="$toUrl('req_complete.png')">
          </template>
          <template v-if="row.issue_type === 'T'">
            <!--                  任务-->
            <img class="icon" v-if="row.is_later === '1' || row.issue_status === '10'"
                 :src="$toUrl('task_red.png')" alt="">
            <img class="icon" v-else-if="row.issue_status === '0'" :src="$toUrl('task_blue.png')" alt="">
            <img class="icon" v-else-if="row.issue_status === '1'" :src="$toUrl('task_yellow.png')" alt="">
            <img class="icon" v-else-if="row.issue_status === '100'" :src="$toUrl('task_green.png')" alt="">
          </template>
          <template v-if="row.issue_type === 'M'">
            <!--                  里程碑-->
            <img class="icon" :src="`${appsettings.imgPrefix}milepost_blue.png`">
          </template>
          <template v-if="row.issue_type === 'F'">父节点</template>
          <template v-if="row.issue_type === 'Q'">缺陷</template>
          <a-tooltip>
            <template slot="title">{{ row.issue_name }}</template>
            <span
                style="margin-left: 5px;margin-right: 15px;vertical-align: middle;cursor: pointer;min-width: 185px"
                @click="openTaskDetailModal(row)">{{
                row.issue_name
              }}</span>
          </a-tooltip>
          <a-tooltip v-if="row.issue_type_name === '任务'">
            <template slot="title">任务详情</template>
            <i class="iconfont icon-liebiao hidden" @click="openTaskDetailModal(row)"></i>
          </a-tooltip>
        </div>
        <!-- <a-input ref="table-name" v-if="editName" v-model="row.project_name" @blur="fieldUpdate(row.project_name)"></a-input>
          <i v-if="!editName" class="iconfont icon-wenbenshuru" @click="clickFoucs"></i> -->
      </template>
    </a-table-column>
    <a-table-column title="项目名称" data-index="project_name" width="200px"></a-table-column>
    <a-table-column title="阶段名称" data-index="phase_name" width="140px"></a-table-column>
    <a-table-column title="优先级" data-index="age" width="90px" align="center">
      <template v-slot:default="_, row">
        <edp-select
            :skin="`status ${row.issue_level === '100' ? 'green' : row.issue_level === '300' ? 'yellow' : row.issue_level === '200' ? 'blue' : row.issue_level === '400' ? 'red' : ''}`"
            size="mini"
            v-model="row.issue_level"
            :db="dbs.prjIssue"
            field-name="issue_level"
            :oid="row.oid"
            :prj-oid="row.prjoid"
            :options="issues_level_list"
            options-type="cat"
            @change="$emit('reload')"
        >
        </edp-select>
      </template>
    </a-table-column>
    <a-table-column title="状态" data-index="" width="70px" align="center">
      <template v-slot:default="_, row">
        <edp-select
            :skin="`status ${row.issue_status === '0' ? 'blue' : row.issue_status === '1' ? 'yellow' : row.issue_status === '100' ? 'green' : row.issue_status === '1000' ? 'gray' : ''}`"
            ref="issue_status"
            size="mini"
            v-model="row.issue_status"
            :db="dbs.prjIssue"
            field-name="issue_status"
            :oid="row.oid"
            :prj-oid="row.prjoid"
            :options="task_status"
            options-type="cat"
            @change="$emit('reload')"
        >
        </edp-select>
      </template>
    </a-table-column>
    <a-table-column title="计划结束" data-index="schedule_end_date" width="130px">
      <template v-slot:default="_, row">
        <edp-date-picker
            style="width: 100%"
            size="mini"
            v-model="row.schedule_end_date"
            :db="dbs.prjIssue"
            field-name="schedule_end_date"
            :oid="row.oid"
            :prj-oid="row.prjoid"
            @change="$emit('reload')"
        >
        </edp-date-picker>
      </template>
    </a-table-column>
  </a-table>
</template>

<style scoped lang="less">

</style>
